<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-if="newFunction" v-click-outside="closeModal">
      <!--Название-->
      <div class="uk-modal-header">
        <!--ID функции-->
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 4"
             style="cursor: pointer;"
             @click="closeModal()">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title" v-if="newFunction.id">
          <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
            <div class="uk-text-bold">
              {{ newFunction.name }}
            </div>
          </div>
        </div>
        <div class="uk-modal-title" v-else>
          <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
            <div>
              Название функции:
            </div>
            <div>
              <input :class="'uk-input ' + (functionErrors['name'] ? ' uk-form-danger ' : '')"
                     v-model="newFunction.name"
                     type="text">
            </div>
          </div>
          <div class="uk-text-muted uk-text-small uk-margin-small">
            Правила названия фукнции
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-grid uk-grid-small" data-uk-grid>
          <!--Категория-->
          <div class="uk-width-1-3">
            <div class="uk-margin-xsmall">Категория</div>
            <select :class="'uk-select ' + (functionErrors['category'] ? ' uk-form-danger ' : '')"
                    v-model="newFunction.category" aria-label="Select">
              <option value="" disabled selected hidden>Выберите категорию</option>
              <option value="other">Другое</option>
              <option value="face">Лицо</option>
              <option value="body">Тело</option>
              <option value="remove">Удаление предметов</option>
              <option value="background">Работа с фоном</option>
            </select>
          </div>
          <!--Цена функци-->
          <div class="uk-width-1-3">
            <div class="uk-margin-xsmall">Цена функции</div>
            <div>
              <input pattern="[0-9]+([\.,][0-9]+)?"
                     step=".01"
                     :class="'uk-input ' + (functionErrors['price'] ? ' uk-form-danger ' : '')"
                     type="number"
                     v-model="newFunction.price">
            </div>
          </div>
          <!--Кредиты-->
          <div class="uk-width-1-3">
            <div class="uk-margin-xsmall">Кредитов</div>
            <div>
              <input pattern="[0-9]+([\.,][0-9]+)?"
                     step=".01"
                     :disabled="newFunction.id"
                     :class="'uk-input ' + (functionErrors['credits'] ? ' uk-form-danger ' : '')"
                     type="number"
                     v-model="newFunction.credits">
            </div>
          </div>
          <!--Иконка функци-->
          <div class="uk-width-1-2">
            <div class="uk-margin-xsmall">Иконка функци</div>
            <div class="uk-grid uk-grid-small" data-uk-grid>
              <div class="uk-width-auto">
                <div class="tm-modal-func-icon uk-background-muted uk-flex uk-flex-middle uk-flex-center">
                  <template v-if="newFunction.id && newFunction.icon">
                    <img class="tm-func-icon" style="width: 40px" :src="newFunction.icon" alt="">
                  </template>
                </div>
              </div>
              <div class="uk-width-expand">
                <div data-uk-form-custom="target: true">
                  <input ref="functionImage" type="file" accept="image/*" @change="handleFileChange">
                  <input :class=" (functionErrors['file'] ? ' uk-form-danger ' : '') + 'uk-input uk-form-width-medium '"
                         type="text" placeholder="Выберите файл" disabled>
                  <button class="uk-button tm-button-success" type="button" tabindex="-1">Выбрать фото</button>
                </div>
              </div>
            </div>
            <div class="uk-text-muted tm-text-small uk-margin-small" style="line-height: 1.3">
              Допустимые форматы: .svg<br>
              После загрузки текущая иконка будет заменена и переменована в название_фукнкции.svg, если изначально не
              было задано
            </div>
          </div>
          <!--Типы функции-->
          <div class="uk-width-1-2">
            <div class="uk-margin-xsmall">Типы функции</div>
            <v-select :class="'tm-v-select ' + (functionErrors['types'] ? ' uk-form-danger ' : '')"
                      v-model="newFunction.functionTypes"
                      :options="types"
                      multiple
                      :disabled="newFunction.id ? true: false"
                      aria-label="Select">
            </v-select>
          </div>
          <!--CAPACITY-->
          <div class="uk-width-1-2" v-if="newFunction.functionTypes && newFunction.functionTypes.includes('capacity')">
            <div class="uk-margin-xsmall">Усилитель:</div>
            <v-select :class="'uk-margin-small-top tm-v-select ' + (functionErrors['types'] ? ' uk-form-danger ' : '')"
                      v-model="newFunction.capacities"
                      :options="capacities.map(function (capacity){
                        return capacity.name;
                      })"
                      multiple
                      :disabled="newFunction.id ? false: false"
                      aria-label="Select">
            </v-select>
          </div>
          <!--Описание-->
          <template v-if="newFunction.id">
            <div class="uk-width-1-1 uk-margin-medium-top">
              <v-tabs class="tm-tabs" v-model="tab">
                <v-tab v-for="languages of languagesList" :key="languages.id">
                  {{ languages.name }}
                </v-tab>
              </v-tabs>
              <v-tabs-items class="tm-tabs-content" v-model="tab">
                <v-tab-item
                    v-for="languages of languagesList"
                    :key="languages.id">
                  <v-card flat>
                    <v-card-text>
                      <div class="uk-margin-xsmall uk-text-small">Заголовок</div>
                      <div class="uk-margin-xsmall">
                        <input class="uk-input" type="text" v-model="tabDataTranslates[languages.id].title">
                        <div class="uk-margin-xsmall uk-text-small">Описание</div>
                        <textarea class="uk-textarea" rows="5"
                                  v-model="tabDataTranslates[languages.id].description"></textarea>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </template>
          <!--Кнопки-->
          <div class="uk-width-1-1 uk-margin-medium-top">
            <button class="uk-button uk-button-default uk-modal-close"
                    @click="closeModal()"
                    type="button">
              Отмена
            </button>
            <template v-if="newFunction.id">
              <button class="uk-button tm-button-success uk-margin-small-left"
                      type="button"
                      @click="saveFunction(false)">
                Сохранить
                <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
              </button>
              <button class="uk-button tm-button-success uk-margin-small-left"
                      type="button"
                      @click="saveFunction(true)">
                Сохранить и закрыть
                <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
              </button>
            </template>
            <template v-else>
              <button class="uk-button tm-button-success uk-margin-small-left"
                      type="button"
                      @click="createFunction()">
                Создать
              </button>
              <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
            </template>
          </div>

          <!--Элементы-->
          <BlockFunctionElements
              v-if="editedFunction && newFunction.functionTypes && newFunction.functionTypes.includes('files')"
              :editedFunction="editedFunction"/>
          <!--Примеры-->
          <BlockFunctionExamples v-if="editedFunction" :editedFunction="editedFunction"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BlockFunctionElements from "../Admin/BlockFunctionElements";
import BlockFunctionExamples from "../Admin/BlockFunctionExamples";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  props: {
    editedFunction: {type: [Object, Array]},
    capacities: {type: Array},
    types: {type: Array},
    local_page_keys: {type: Object}
  },
  data() {
    return {
      newFunction: this.editedFunction ? {...this.editedFunction} :
          {category: ''},
      functionErrors: {},
      loading: false,
      tab: null,
      tabDataTranslates: [],
      functionTranslatesTitle: [],
      functionTranslatesDescription: [],
      languagesList: []
    };
  },
  components: {BlockFunctionElements, BlockFunctionExamples},
  computed: {
    hasChanged() {
      if (this.editedFunction)
        return Object.keys(this.newFunction).some(field => this.newFunction[field] !== this.editedFunction[field]);
      else
        return Object.values(this.newFunction).some((value) => {
          return value.length > 0;
        });
    }
  },
  methods: {
    async saveFunction(closeDialog) {
      this.functionErrors = {};
      if (!this.newFunction.category || this.newFunction.category.trim() === '') {
        this.functionErrors.category = ['The category is required'];
        return;
      } else if (!this.newFunction.price || this.newFunction.price <= 0) {
        this.functionErrors.price = ['The price is required and greater than 0'];
        return;
      }
      let data = new FormData();
      this.loading = true;
      if (this.$refs.functionImage.files && this.$refs.functionImage.files[0]) {
        data.append('icon', this.$refs.functionImage.files[0])
      }
      data.append('price', parseFloat(this.newFunction.price).toFixed(2))
      data.append('credits', parseFloat(this.newFunction.credits).toFixed(2))
      data.append('category', this.newFunction.category)
      data.append('id', this.newFunction.id)
      data.append('types', JSON.stringify(this.newFunction.functionTypes))
      data.append('capacities', JSON.stringify(this.newFunction.capacities))
      data.append('translates', JSON.stringify(this.tabDataTranslates))

      await axios.post(`${url}/func/` + this.newFunction.id + `/update`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(async response => {
        await this.$store.dispatch('functionsEdit/functionsList');
        this.newFunction = {...this.editedFunction};
        UIkit.notification({message: 'Function is saved', pos: 'top-center', status: 'success', timeout: 1500})
        this.$emit('reloadLocalize');
        if (closeDialog) {
          this.$emit('close');
        }
      }).catch(err => {
        if (err.response.data && err.response.data.errors) {
          this.functionErrors = err.response.data.errors;
        }
        UIkit.notification({
          message: "Function isn't saved." + err.response.data.message ?? '',
          pos: 'top-center',
          status: 'error',
          timeout: 1500
        })
      });
      this.loading = false;
    },
    async createFunction() {
      this.functionErrors = {};
      if (!this.newFunction.name || this.newFunction.name <= 0) {
        this.functionErrors.name = ['The name is required'];
        return;
      } else if (!this.newFunction.category || this.newFunction.category.trim() === '') {
        this.functionErrors.category = ['The category is required'];
        return;
      } else if (!this.newFunction.price || this.newFunction.price <= 0) {
        this.functionErrors.price = ['The price is required and greater than 0'];
        return;
      } else if (!this.newFunction.credits || this.newFunction.credits <= 0) {
        this.functionErrors.credits = ['The credits is required and greater than 0'];
        return;
      } else if (!this.$refs.functionImage.files || this.$refs.functionImage.files.length <= 0) {
        this.functionErrors.file = ['The file is required'];
        return;
      }
      let data = new FormData();
      this.loading = true;
      data.append('icon', this.$refs.functionImage.files[0])
      data.append('price', parseFloat(this.newFunction.price).toFixed(2))
      data.append('credits', parseFloat(this.newFunction.credits).toFixed(2))
      data.append('category', this.newFunction.category)
      data.append('name', this.newFunction.name)
      data.append('types', JSON.stringify(this.newFunction.functionTypes))
      data.append('capacities', JSON.stringify(this.newFunction.capacities))

      await axios.post(`${url}/func`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(async response => {
        await this.$store.dispatch('functionsEdit/functionsList');
        if (response.data && response.data.function) {
          await this.$emit('created', response.data.function.id);
        }
        this.newFunction = {...this.editedFunction};
        UIkit.notification({message: 'Function is created', pos: 'top-center', status: 'success', timeout: 1500})
      }).catch(err => {
        if (err.response.data && err.response.data.errors) {
          this.functionErrors = err.response.data.errors;
        }
        UIkit.notification({
          message: "Function isn't created." + err.response.data.message ?? '',
          pos: 'top-center',
          status: 'error',
          timeout: 1500
        })
      });
      this.loading = false;
    },
    closeModal() {
      this.$emit('close');
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type !== 'image/svg+xml') {
        this.$refs.functionImage.value = '';
        alert('Не верный формат изображения.');
      }
    },
    async getFunctionTranslates(newFunction) {
      await this.$store.dispatch('funcElements/funcTranslates', newFunction.name);
      let data = await this.$store.getters['funcElements/funcTranslates'];
      this.functionTranslatesTitle = data.data.title;
      this.functionTranslatesDescription = data.data.description;
      this.languagesList = data.data.languages;
      this.initTab();
    },

    initTab() {
      this.tabDataTranslates = this.languagesList.reduce((acc, language) => {
        acc[language.id] = {
          title: '',
          description: '',
        };
        return acc;
      }, {});

      this.functionTranslatesTitle.forEach((item) => {
        this.tabDataTranslates[item.language.id].title = item.text;
      });

      this.functionTranslatesDescription.forEach((item) => {
        this.tabDataTranslates[item.language.id].description = item.text;
      });
    }
  },
  async created() {
    this.getFunctionTranslates(this.newFunction);
  }
}
</script>